import { API } from 'aws-amplify';

export const create = async (advisor) => API.put('eventmanagerAdminApi', `/advisors`, {body: advisor});

export const read = async () => API.get('eventmanagerAdminApi', '/advisors', {});

export const update = async (advisor) => API.post('eventmanagerAdminApi', `/advisors`, {body: advisor});

export const del = async (advisor) => API.del('eventmanagerAdminApi', `/advisors`, {body: advisor});
